import axios from 'axios';

console.log("API Base URL:", process.env.VUE_APP_API_BASE_URL);

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: process.env.VUE_API_BASE_URL ?? 'https://aibot.uz/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized, logging out...");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
